import React from 'react'

const AboutSnippet = () => {
  return (
    <div className='  text-white mx-auto flex max-w-3xl items-center justify-between  p-4 lg:px-8'>
        <div className=" title-p text-2xl">CURRENTLY CRAFTING <br /> EXPERIENCES AT KHRC</div>
        <div className=" title-p text-2xl">
        (2021 – PRESENT)
        </div>
       </div>
  )
}

export default AboutSnippet